<template>
  <div :class="success ? 'happy' : 'sad'" class="response">
    <span v-if="success">
      {{ $t('views.Contact.responseOk') }}
    </span>
    <span v-else>{{ $t('views.Contact.responseError') }}</span>
    <button type="button" @click="$emit('reset-success')">&times;</button>
  </div>
</template>
<script>
export default {
  props: {
    success: {
      type: Boolean,
      requred: true,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../scss/base/colors';

.response {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1.5rem 0 0;
  padding: 0.5rem 1rem;
  color: $white;
  border-radius: 5px;

  &.happy {
    background: $green;
  }
  &.sad {
    background: $red;
  }

  button {
    background: none;
    border: 0;
    font-size: 1.5em;
    line-height: 1em;
  }
}
</style>
